import React from "react";
import { IoLogoFacebook, IoLogoGithub } from "react-icons/io";

const Footer = () => {
  return (
    <div className="footer">
      {/* <h2 className="footer_head">Subscrice Newsletter</h2> */}

      {/* <form>
        <input type="email" className="email" placeholder="example@email.com" />
        <input type="submit" value="subcribe" className="button" />
      </form> */}
      <div className="contact">
        <h3>Social media </h3>
        <ul className="socials">
          <li className="social facebook">
            <a
              href="https://www.facebook.com/profile.php?id=100028077012854"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoFacebook size="2rem" color="white" />
            </a>
          </li>
          <li className="social github">
            <a
              href="https://github.com/satendrassharma"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoGithub size="2rem" color="white" />
            </a>
          </li>
          {/* <li className="social youtube">
            <a src="">
              <IoLogoYoutube size="2rem" color="white" />
            </a>
          </li> */}
        </ul>
      </div>
      <h2 className="footer_head">
        <span className="red">Satendra</span>
        <span> Sharma</span>{" "}
      </h2>
    </div>
  );
};

export default Footer;
